<template>
  <div class="mails pane">
    <h3>Recent mails</h3>
    <div class="mail" v-for="mail of recentMails" :key="mail.id">
      <strong>To:</strong>
      <router-link
        :to="{ path: `/users/${mail.to}` }"
        v-text="getRecipientName(mail.to)" />
      <br />
      <strong>Date:</strong>
      {{ mail.created.toDate() | moment('MMMM Do YYYY, h:mm:ss a') }}
      <br />
      <strong>{{ mail.subject }}</strong>
      <br />
      <div v-text="mail.message" />
      <small>
        <span v-if="mail.read">
          Read {{ mail.read.toDate() | moment('from') }}
        </span>
        <span v-else>Unread</span>
      </small>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Mails',
  computed: {
    ...mapState(['recentMails']),
    ...mapGetters(['getUser'])
  },
  methods: {
    getRecipientName (id) {
      const user = this.getUser(id)
      return user ? user.name : id
    }
  }
}
</script>

<style scoped>
.mail {
  border-top: 1px solid #ccc;
  padding: 1em;
}
</style>
